module.exports = __webpack_public_path__ + "static/media/banner4.3e06d8aa.png";